import useSWR from 'swr'
import { STORE_DEPOSIT } from '../../constants/LOCALKEYS'

const KEY = STORE_DEPOSIT

let swrData = null

export function useDepositStore(init) {
	const { data, mutate } = useSWR<any>(
		KEY,
		async () => {
			if (!swrData) {
				return init
			} else {
				return swrData
			}
		},
		{
			revalidateOnFocus: false,
			revalidateOnReconnect: false,
			revalidateIfStale: false,
		}
	)

	return {
		data,
		mutate: (value: any) => {
			swrData = value
			return mutate()
		},
	}
}
